import { animate, spring } from 'https://cdn.jsdelivr.net/npm/motion@10.16.4/+esm';

const fadeInScaleDefaultParams = {
  opacity: {
    exit: 0,
    enter: 1,
  },
  scale: {
    exit: 0.9,
    enter: 1,
  },
  y: {
    exit: 100,
    enter: 0,
  },
};

export const animations = {
  fadeInScale: ({
    opacity = fadeInScaleDefaultParams.opacity,
    scale = fadeInScaleDefaultParams.scale,
    y = fadeInScaleDefaultParams.y,
  } = fadeInScaleDefaultParams) => {
    const transition = { easing: 'ease' };
    return {
      name: `fade`,
      onBeforeEnter: (el) => {
        el.style.opacity = opacity.exit;
        el.style.transform = `translateY(${y.exit}) scale(${scale.exit})`;
      },
      onEnter: (el, done) =>
        animate(
          el,
          {
            opacity: [null, opacity.enter],
            y: [null, y.enter],
            scale: [null, scale.enter],
          },
          transition
        ).finished.then(done),
      onExit: (el, done) =>
        animate(
          el,
          {
            opacity: [null, opacity.exit],
            y: [null, y.exit],
            scale: [null, scale.exit],
          },
          transition
        ).finished.then(done),
    };
  },
  fade: ({ exit = 0, enter = 1 } = { exit: 0, enter: 1 }) => {
    const transition = { easing: 'ease' };
    return {
      name: `fade`,
      onBeforeEnter: (el) => (el.style.opacity = exit),
      onEnter: (el, done) => animate(el, { opacity: [null, enter] }, transition).finished.then(done),
      onExit: (el, done) => animate(el, { opacity: [null, exit] }, transition).finished.then(done),
    };
  },
  slideFromRight: ({ enter = '0%', exit = '100%' } = { enter: '0%', exit: '100%' }) => {
    const transition = { damping: 15 };
    return {
      name: `slideFromRight`,
      onBeforeEnter: (el) => (el.style.transform = `translateX(${exit})`),
      onEnter: (el, done) =>
        animate(el, { transform: [null, `translateX(${enter})`] }, { easing: spring(transition) }).finished.then(done),
      onExit: (el, done) =>
        animate(el, { transform: [null, `translateX(${exit})`] }, { easing: spring(transition) }).finished.then(done),
    };
  },
  slideFromLeft: ({ enter = '0%', exit = '-100%' } = { enter: '0%', exit: '-100%' }) => {
    const transition = { damping: 15 };
    return {
      name: `slideFromLeft`,
      onBeforeEnter: (el) => (el.style.transform = `translateX(${exit})`),
      onEnter: (el, done) =>
        animate(el, { transform: [null, `translateX(${enter})`] }, { easing: spring(transition) }).finished.then(done),
      onExit: (el, done) =>
        animate(el, { transform: [null, `translateX(${exit})`] }, { easing: spring(transition) }).finished.then(done),
    };
  },
  removeItem: () => {
    const transition = { easing: spring({ damping: 16 }) };
    return {
      name: 'removeItem',
      onBeforeEnter: (el) => {
        el.style.transform = `translateX(50%)`;
        el.style.opacity = 0;
      },
      onEnter: (el, done) =>
        animate(el, { opacity: [null, 1], transform: [null, `translateX(0%)`] }, transition).finished.then(done),
      onExit: (el, done) =>
        animate(el, { opacity: [null, 0], transform: [null, `translateX(50%)`] }, transition).finished.then(done),
    };
  },
  progress: (el, to) => animate(el, { transform: [null, `translateX(${to})`] }, { easing: spring({ damping: 15 }) }),
};
